/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush on 7/9/20
 *
 */

export const MenuAction = Object.freeze({
	MOVE_TO_TRASH: "MOVE_TO_TRASH",
	DELETE_FOREVER: "DELETE_FOREVER",
	DELETE: "DELETE",
	ARCHIVE: "ARCHIVE",
	UNARCHIVE: "UNARCHIVE",
	RESTORE: "RESTORE",
	OPEN: "OPEN",
	MOVE: "MOVE",
	COPY: "COPY",
	RENAME: "RENAME",
	VIEW: "VIEW",
	EDIT: "EDIT",
	SHARE: "SHARE",
	SHARE2: "SHARE2",
	INVITE: "INVITE",
	INVITE_MULTIPLE: "INVITE_MULTIPLE",
	UNSHARE: "UNSHARE",
	UNSHARE2: "UNSHARE2",
	LINK: "LINK",
	UNLINK: "UNLINK",
	PRINT: "PRINT",
	SELECT: "SELECT",
	NEW_FOLDER: "NEW_FOLDER",
	NEW_LINK: "NEW_LINK",
	UPLOAD_FILE: "UPLOAD_FILE",
	UPLOAD_FOLDER: "UPLOAD_FOLDER",
	DOWNLOAD: "DOWNLOAD",
	SWITCH: "SWITCH",
	PREVIEW: "PREVIEW",
	DISABLE: "DISABLE",
	SWITCH_ACCOUNT: "SWITCH_ACCOUNT",
	ADD_RIGHT: "ADD_RIGHT",
	ADD_LEFT: "ADD_LEFT",
	MAKE_PROSPECT: "MAKE_PROSPECT",
	MAKE_CLIENT: "MAKE_CLIENT",
	DRAFT: "DRAFT",

})
